import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Hero from '../../components/Hero';
import Heading from '../../components/Heading';
import grid from '../../design-language/3rd-party/flexboxgrid.module.css';

const HeroPageIntro = ({ description, title }) => (
  <Hero name="PageIntro" horizontalPadding="Small">
    <div className={classnames([grid.row], [grid.centerXs])}>
      <div className={[grid.colMd8]}>
        <Heading center>{title}</Heading>

        {description && <p>{description}</p>}
      </div>
    </div>
  </Hero>
);

HeroPageIntro.propTypes = {
  description: PropTypes.node,
  title: PropTypes.string.isRequired,
}

HeroPageIntro.defaultProps = {
  description: null,
}

export default HeroPageIntro;
